module.exports = __webpack_public_path__ + "img/part2.c6e25d92.png";